module.exports = __webpack_public_path__ + "static/tigre-0170291e02b1b8a4fb9eb78f47c750d6.png";